import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware(
  (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    if (to.name === 'mypage-withdrawal-complete' && from.name !== 'mypage-withdrawal') {
      throw createError({
        statusCode: 404,
        message: 'お探しのページが見つかりませんでした',
        fatal: true,
      });
    }
  }
);
